import { axiosWithConfig } from '@assembly/config/axios'

export const getAllCapabilites = (payload: any) => {
  return axiosWithConfig.post(
    `/contractor/dashboard/capabilities/search`,
    payload,
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
  )
}
